module.exports = __webpack_public_path__ + "static/media/9-5.36e71f60.mp3";